/* eslint-disable import/prefer-default-export */
import {
  LOAD_DATA_GLOBAL,
  UPDATE_DATA_GLOBAL,
  getAction,
} from './type.actions';

export const LoadDataGlobalAction = (data) => getAction(LOAD_DATA_GLOBAL, data);
export const UpdateDataGlobalAction = (data) => getAction(UPDATE_DATA_GLOBAL, data);
